const translations = {
  VCRSwitchConfirm:
    'Flaga określająca włączoną obsługę Wirtualnych Kas Fiskalnych zostanie zmieniona na przeciwną. Kontynuować?',
};

export default translations;
